/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4.908 4.922a10.01 10.01 0 1 1 0 14.156.9.9 0 0 1 1.272-1.273 8.21 8.21 0 1 0-2.297-7.128.9.9 0 1 1-1.776-.29 10.01 10.01 0 0 1 2.8-5.465Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.403 7.819h2.224a.9.9 0 1 1 0 1.8h-2.223a.567.567 0 0 0-.212 1.094l2.258.904a2.368 2.368 0 0 1-.882 4.564h-2.222a.9.9 0 1 1 0-1.8h2.22a.569.569 0 0 0 .213-1.094l-2.258-.904a2.367 2.367 0 0 1 .882-4.564Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.986 6.54a.9.9 0 0 1 .9.9v.912a.9.9 0 1 1-1.8 0V7.44a.9.9 0 0 1 .9-.9ZM11.986 14.748a.9.9 0 0 1 .9.9v.913a.9.9 0 0 1-1.8 0v-.913a.9.9 0 0 1 .9-.9ZM3.631 13.3a.9.9 0 0 1-1.273 0L.402 11.344a.9.9 0 0 1 1.273-1.273l1.32 1.32 1.32-1.32a.9.9 0 0 1 1.272 1.273L3.631 13.3Z"
})), "0 0 24 24", "RefundLight");